import { useState, useCallback } from "react";
import { searchCustomerForActivations } from "../../api/customer";

export const useCustomerSearch = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const searchCustomer = useCallback(async (query) => {
    setLoading(true);
    setError(null);
    setData(null);

    try {
      const { data } = await searchCustomerForActivations(query);
      setData(data.data);
    } catch (err) {
      if (err.response) {
        let { data } = err.response;
        setError(data.message);
      } else {
        setError("Something Error Happened");
      }
    } finally {
      setLoading(false);
    }
  }, []);

  const resetData = () => {
    setData(null);
  };

  return { data, loading, error, searchCustomer, resetData };
};
